export default "__VITE_ASSET__BmpRFb08__"